import { Component, OnInit } from '@angular/core';
import { SignalrCoreService } from '@shared/signalr-core-service';
import { SignalrStates } from '@shared/signalr-core-service-base';

@Component({
    selector: 'app-signalR-status-viewer',
    templateUrl: './signalR-status-viewer.component.html',
    styleUrls: ['./signalR-status-viewer.component.scss']
})
export class SignalRStatusViewerComponent implements OnInit {
    
    constructor(public signalRService: SignalrCoreService) { }

    ngOnInit() { }

    SignalrStates = SignalrStates;
}
